import React from 'react';
import { Link} from 'react-router-dom';
import logo from '../images/Logo-black.png'




const Header=() => {

    return(
        <div className='footer'>
            <img className='footerLogo' src={logo} alt='Raili Custom Bridal Logo'></img>
            <div className='footerInfo'>
            <div className='footerContact'>
                <div>Contact Us</div>
                <div>Text: 801-602-8356</div>
                <div>Email: <br/>railicustombridal@gmail.com</div>
            </div>
            <div className='footerLinks'>
            <div>Links</div>
            <Link to='/' className='footerLink'>Home</Link>
            <Link to='/ourBrides' className='footerLink'>Our Brides</Link>
            <Link to='/schedule' className='footerLink'>Schedule a Consultation</Link>
            <Link to='/aboutRaili' className='footerLink'>About Raili</Link>
            </div>
            </div>
        </div>
    );
}

export default Header;